import { styled } from '@mui/material/styles';
import { sortBy } from 'lodash';
import React from 'react';
import { Link } from 'react-router';

const StyledLink = styled(Link)(() => ({
    color: '#0000EE',            // unvisited link blue
    textDecoration: 'underline' // underline by default
}));

const Sites = props => {
    const { rows } = props;

    return sortBy(rows, 'name').map((row, index) => {
        return (
            <React.Fragment key={row.id}>
                <StyledLink to={`/sites/${row.id}`}>{row.name}</StyledLink>
                {index !== rows.length - 1 ? <>,&nbsp;</> : null}
            </React.Fragment>
        );
    }
    );
};

export default Sites;
